import { render, staticRenderFns } from "./AddSeniorBill.vue?vue&type=template&id=2bf80f48&scoped=true"
import script from "./AddSeniorBill.vue?vue&type=script&lang=js"
export * from "./AddSeniorBill.vue?vue&type=script&lang=js"
import style0 from "./AddSeniorBill.vue?vue&type=style&index=0&id=2bf80f48&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf80f48",
  null
  
)

export default component.exports